export enum PersonAuthorizations {
  PersonAnprQuery = 'PERSONA.ANPR.QUERY',
  PersonAnprRett = 'PERSONA.ANPR.UPDATE',
  HistoryPerson = 'PERSONA.STORICO.READ',
  HistoryInsert = 'PERSONA.STORICO.INS',
  HistoryCancelEmigration = 'PERSONA.STORICO.CANC.ITA',
}

export enum PersonDossierAuthorizations {
  CaricatoreFascicolo = 'CARICATORE.FASCICOLO',
}

export const uploadDossier = [PersonDossierAuthorizations.CaricatoreFascicolo];

export const PersonDossierAuthorizationsList = [...uploadDossier];

export const PersonAuthorizationsList = [PersonAuthorizations.PersonAnprQuery];
